module.exports = __webpack_public_path__ + "img/map_marker copy.0632ef09.svg";